import moment from 'moment';

export const convertToISOString = (date, specialFormat = false) => {
    try {
        if (specialFormat) {
            if (moment(date, 'MM/DD/YYYY').toISOString()) {
                return moment(date, 'MM/DD/YYYY').toISOString();
            }
        }
        var parsedDate = moment(new Date(date));
        if (!parsedDate.isValid()) {
            parsedDate = moment(date, 'MMM D, YYYY');
        }
        if (!parsedDate.isValid()) {
            throw new Error('Invalid date format');
        }
        return parsedDate.toISOString();
    } catch (error) {
        console.log(`Format date error. ${error.message}`);
        return 'NA';
    }
};
